import React from 'react';
import {FormattedMessage} from 'react-intl';
import {RetailerItemFormModes} from 'pages/Rewards/utils';

export const ReceiptItemImageType = 'retailerItemImage';  // used for cropping step

const baseConfig = {
  key: 'receiptItemForm',
  fields: [
    {
      type: 'ngcEndpointDropdown',
      name: 'ngcApiId',
      props: {
        labelKey: 'editbreak.account_info.ngc_api',
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='editbreak.account_info.ngc_api' />
          </div>
        ),
        options: [],
        required: true,  
      }

    },
    {
      name: 'ngcDeliveryType',
      type: 'dropdown',
      props: {
        labelKey: 'editbreak.account_info.ngc_delivery_type',
        label: (
          <div>
            <i className='asterisk icon inline' />
            NGC Delivery Type
            {/* <FormattedMessage id='rewardsStore.modal.retailerItem.label.level' /> */}
          </div>
        ),
        options: [{
            text: 'NGC Sends Email',
            value: 'email'
          },
          {
            text: 'NGC Delivers Code to us (we send email)',
            value: 'api'
          }
        ],
        value: 'api',
        defaultValue: 'api',
        required: true
      }
    },

    {
      name: 'retailerId',
      type: 'retailerDropdown',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.retailer' />
          </div>
        ),
        required: true
      }
    },
    {
      name: 'price',
      type: 'retailerItemCurrency',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.price' />
          </div>
        ),
        required: true,
        validationRules: [
          {
            type: 'IntegerFormat'
          },
          {
            type: 'InclusiveRange',
            params: {
              min: 1,
              max: 100000
            }
          }
        ]
      }
    },
    {
      name: 'cost',
      type: 'retailerItemCurrency',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.cost' />
          </div>
        ),
        required: true,
        validationRules: [
          {
            type: 'NumberFormat'
          },
          {
            type: 'InclusiveRange',
            params: {
              min: 1,
              max: 100000
            }
          }
        ]
      }
    },
    {
      name: 'title',
      type: 'text',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.title' />
          </div>
        ),
        required: true,
        validationRules: [
          {
            type: "ProperCurrencyValue",
            params: {
              currencyField: "price"
            }
          }
        ]
      }
    },
    {
      name: 'description',
      type: 'contenteditable',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.description' />
          </div>
        ),
        required: true
      }
    },
    {
      name: 'legal',
      type: 'contenteditable',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.legal' />
          </div>
        ),
        required: true
      }
    },
    {
      name: 'imageId',
      idFor: 'image',
      type: 'receiptItemImagePicker',
      props: {
        imageType: ReceiptItemImageType,
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='rewardsStore.modal.retailerItem.label.image' />
          </div>
        ),
        required: true
      }
    }
  ]
};

export default {
  [RetailerItemFormModes.Create]: baseConfig,
  [RetailerItemFormModes.Update]: {
    ...baseConfig,

    // users cannot change vendor on existing items.
    fields: baseConfig.fields.filter(field => field.name !== 'retailerId')
  }
};



// WEBPACK FOOTER //
// ./public/pages/Receipt/receiptItemFormConfig.jsx